import classes from './Sponsors.module.css';

import logoTomeco from '../../assets/images/logo-tomeco.png';
import logoSwaAernouts from '../../assets/images/logo-swa-aernouts.jpeg';
import logoMvLightSound from '../../assets/images/logo-mv-light-sound.png';
import logoJNSanitair from '../../assets/images/logo-j-n-sanitair.png';
import logoBogaerts from '../../assets/images/logo-bogaerts.png';
import logoOnderDenToren from '../../assets/images/logo-onder-den-toren.png';
import logoFrijters from '../../assets/images/logo-frijters.png';
import logoZwaluw from '../../assets/images/logo-zwaluw.png';
import logoFarWest from '../../assets/images/logo-far-west.png';
import logoVwb from '../../assets/images/logo-vwb.png';
import logoThijsAnthonissen from '../../assets/images/logo-thijs-anthonissen.png';
import logoKersemansElektro from '../../assets/images/logo-kersemans-elektro.png';
import logoKersemansBouwwerken from '../../assets/images/logo-kersemans-bouwwerken.png';
import logoJanBrughmans from '../../assets/images/logo-jan-brughmans.png';

interface Sponsor {
  name: string;
  logo: string;
  website?: string;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  borderColor?: string;
  cropStyle?: React.CSSProperties;
}

const sponsors: Sponsor[] = [
  {
    name: 'Swa Aernouts',
    logo: logoSwaAernouts,
    website: 'https://www.facebook.com/SwaAernoutsBvba',
  },
  {
    name: 'Tomeco',
    logo: logoTomeco,
    website: 'https://www.feelgoodtomatoes.com',
  },
  {
    name: 'MV Light & Sound',
    logo: logoMvLightSound,
    backgroundColor: '#000000',
    hoverBackgroundColor: '#1a1a1a',
    borderColor: '#ffffff',
    website: 'https://www.facebook.com/MVLightSound'
  },
  {
    name: 'J.N. Sanitair',
    logo: logoJNSanitair,
    website: 'https://www.facebook.com/jninstallateur.be',
  },
  {
    name: 'Cafe Onder Den Toren',
    logo: logoOnderDenToren,
    website: 'https://www.facebook.com/p/Cafe-Onder-den-toren-100051569753917',
  },
  {
    name: 'Gararge Frijters',
    logo: logoFrijters,
    website: 'https://www.garagefrijters.be',
  },
  {
    name: 'Cafe De Zwaluw',
    logo: logoZwaluw,
    website: 'https://www.cafe-de-zwaluw.be',
  },
  {
    name: 'Cafe Far West',
    logo: logoFarWest,
    website: 'https://www.cafefarwest.com',
  },
  {
    name: 'Bogaerts',
    logo: logoBogaerts,
    website: 'https://bogaerts-engineering.be',
  },
  {
    name: 'Brent Van Wouwe',
    logo: logoVwb,
    website: 'https://bizzy.ai/nl/be/0754400078/v-w-b-algemene-karweiwerken',
  },
  {
    name: 'Thijs Anthonissen',
    logo: logoThijsAnthonissen,
    website: 'https://www.anthonissenbouwwerken.be/',
  },
  {
    name: 'Kersemans Elektro',
    logo: logoKersemansElektro,
    website: 'https://kersemanselektro.be/',
  },
  {
    name: 'Kersemans Bouwwerken',
    logo: logoKersemansBouwwerken,
    website: 'https://bizzy.ai/nl/be/0778275342/bouwwerken-kersemans',
  },
  {
    name: 'Jan Brughmans',
    logo: logoJanBrughmans,
    website: 'https://www.grondwerkenbrughmans.be/',
  },
];

const Sponsors = () => {
  const duplicatedSponsors = [...sponsors, ...sponsors];
  const randomStartIndex = Math.floor(Math.random() * sponsors.length);
  const reorderedSponsors = [
    ...duplicatedSponsors.slice(randomStartIndex),
    ...duplicatedSponsors.slice(0, randomStartIndex),
  ];

  return (
    <div className={classes.sponsorsContainer}>
      <h2 className={classes.title}>Onze Sponsors</h2>
      <div className={classes.sponsorsWrapper}>
        <div className={classes.gradientLeft} />
        <div className={classes.sponsorsGrid}>
          {reorderedSponsors.map((sponsor, index) =>
            sponsor.website ? (
              <a
                key={`sponsor-${index}`}
                href={sponsor.website}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.sponsorLink}
                style={
                  {
                    backgroundColor: sponsor.backgroundColor || 'white',
                    '--hover-bg-color': sponsor.hoverBackgroundColor || '#f5f5f5',
                    borderColor: sponsor.borderColor || 'transparent',
                  } as React.CSSProperties
                }
              >
                <img
                  src={sponsor.logo}
                  alt={`${sponsor.name} logo`}
                  className={classes.sponsorLogo}
                  style={sponsor.cropStyle}
                />
              </a>
            ) : (
              <div
                key={`sponsor-${index}`}
                className={classes.sponsorLink}
                style={
                  {
                    backgroundColor: sponsor.backgroundColor || 'white',
                    '--hover-bg-color': sponsor.hoverBackgroundColor || '#f5f5f5',
                    borderColor: sponsor.borderColor || 'transparent',
                  } as React.CSSProperties
                }
              >
                <img
                  src={sponsor.logo}
                  alt={`${sponsor.name} logo`}
                  className={classes.sponsorLogo}
                  style={sponsor.cropStyle}
                />
              </div>
            )
          )}
        </div>
        <div className={classes.gradientRight} />
      </div>
    </div>
  );
};

export default Sponsors;
